import { permissionsRequestsTyped } from "@/api/(requests)/permissionsTyped";
import type { PostUserPermissionsPayload } from "@/core/types/(api)/permissions";
import type { UserPermissions, UUID } from "@/core/types";

export async function updateUserPermissions(
  userId: UUID,
  body: PostUserPermissionsPayload,
): Promise<UserPermissions> {
  return permissionsRequestsTyped.update_user_permissions({
    body,
    urlParams: { userId },
  });
}
